<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <import-edit-form @on-submit="onImportEditSubmit"></import-edit-form>
    </div>
  </div>
</template>
<script>
import ImportEditForm from "./ImportEditForm.vue";

export default {
  components: {
    ImportEditForm
  },
  data() {
    return {
      importEditModel: {}
    };
  },
  methods: {
    onImportEditSubmit(model) {
      this.importEditModel = model;
      // this.$http.post(
      //   this.$apiBaseUrl + 'imports/' + this.importEditModel.id, Object.assign(this.importEditModel)
      // ).then(response => {
      // }, response => {
      // });
    }
  }
};
</script>
<style></style>
